<div
  class="d-flex justify-content-center align-items-center flex-column min-vh-100"
>
  @if (isLoading) {
  <div class="h-100">
    <div
      class="mt-20 d-flex justify-content-center align-items-center flex-column"
    >
    <h1 class="mt-3 mb-5 text-center">La tua fantastica App sta caricando</h1>

      <mat-progress-spinner
        class="spinner"
        mode="indeterminate"
        diameter="70"
        strokeWidth="5"
      ></mat-progress-spinner>
    </div>
    <div
      class="mt-10 d-flex justify-content-center align-items-center flex-column"
    >
      <h2 class="mt-5 text-center">Attendi solo un istante...</h2>
    </div>
  </div>
  } @if (!isLoading) {
  <div class="h-100">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img
        mat-card-image
        class="col-md-3 col-10"
        src="izy_image_3_small.png"
        alt="Home image"
      />
      <h2>Seleziona la tua Partita IVA:</h2>
      <p>A quale account vuoi accedere?</p>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-column">
      @for (org of organizations; track org.id) {
      <button
        matButton="filled"
        type="button"
        class="btn m-2 primary-button"
        [routerLink]="['/', org.id, 'dashboard']"
      >
        {{ org.name }}
      </button>
      } @if (organizations.length === 0) {
      <div class="d-flex justify-content-center align-items-center flex-column text-center">
        <div class="mt-1">Non hai ancora registrato nessuna Partita Iva sul nostro Servizio.</div>
        <div class="mt-3 text-muted">Hai necessità? Contattaci senza impegno: {{email}}</div>
        <div class="mt-3 text-muted">Oppure:</div>
      </div>
      <!-- TODO: registrazione di una nuova organizzazione non ancora approvata, da implementare -->
      <div class="d-flex justify-content-center align-items-center flex-column">
        <!-- <button 
          (click)="bookCallRedirect()"
          matButton="filled"
          type="button"
          class="btn mt-3 m-2 primary-button"
        >
        <mat-icon>co_present</mat-icon>
          Prenota una consulenza gratuita
        </button> -->
      </div>
      }
      <button 
          (click)="goToLogout()"
          matButton="outlined"
          type="button"
          class="btn mt-3 m-2"
        >
        <mat-icon>logout</mat-icon>
          Logout
    </button>
    
    </div>

    <!-- <div class="mt-2 d-flex justify-content-center align-items-center flex-column">
      <p>oppure</p>

      <button
        matButton="filled"
        type="button"
        class="btn m-2"
        [routerLink]="['/', 'new-organization']"
      >
      <mat-icon>add</mat-icon>
        Crea nuova organizzazione
      </button>
    </div> -->
  </div>
  }
</div>
